import React from 'react';
import { Radio } from 'lucide-react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

function formatSimTime(ms: number): string {
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `T+${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

const InjectFeedWidget: React.FC<WidgetProps> = () => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';
  const injects = state?.tabletop?.publicInjects ?? [];

  if (injects.length === 0) {
    return (
      <div className={`flex items-center justify-center h-full text-sm ${isDark ? 'text-white/30' : 'text-slate-400'}`}>
        No public injects yet
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full px-3 py-2 gap-2 overflow-y-auto">
      {injects.map((inject, i) => (
        <div key={inject.seq} className="flex items-start gap-2">
          <Radio size={13} className={`mt-0.5 flex-shrink-0 ${i === 0 ? 'text-primary' : isDark ? 'text-white/20' : 'text-slate-300'}`} />
          <div className="min-w-0">
            <p className={`text-sm font-mono ${isDark ? 'text-white/30' : 'text-slate-400'}`}>{formatSimTime(inject.simTimeMs)}</p>
            <p className={`text-sm leading-snug ${isDark ? 'text-white/90' : 'text-slate-800'}`}>{inject.content}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InjectFeedWidget;
